import * as React from 'react';
import {
    View,
    Text,
    StyleSheet,
    ActivityIndicator,
    TouchableOpacity
} from 'react-native';

import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';

interface IProps {
    loading: boolean,
    action: Function,
    page: number,
    total: number
}

const NextPageLoaderGeneric: React.FC<IProps> = function ({ loading, action, page, total }) {

    React.useEffect(() => {
        return () => {
        }
    }, [])

    return <View style={styles.container}>
        {
            loading
                ? <ActivityIndicator size={24} style={styles.spinner} color={Colors.shades._7} />
                : total > page
                    ? <TouchableOpacity
                        onPressIn={() => action()}
                        style={styles.button}
                    >
                        <Text style={styles.buttonText}>Load more products</Text>
                    </TouchableOpacity>
                    : null
        }
    </View>
}

NextPageLoaderGeneric.defaultProps = {
    loading: true
}

export default NextPageLoaderGeneric

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 6,
        paddingVertical: 10,
    },
    button: {
        padding: 10,
        borderRadius: 16,
        backgroundColor: Colors.shades._4,
        justifyContent: 'center',
        alignItems: 'center'
    },
    buttonText: {
        ...FontStyles.medium,
        ...FontStyles.size12,
        ...FontStyles.lh14,
        ...FontStyles.dark,
    },
    spinner: {}
})
